import { IconButton, Tooltip } from '@mui/material';
import { useSettings } from 'src/hooks/use-settings';
import Moon01Icon from '@untitled-ui/icons-react/build/esm/Moon01';
import SunIcon from '@untitled-ui/icons-react/build/esm/Sun';

export const ThemeToggle = () => {
  const settings = useSettings();

  const handleThemeToggle = () => {
    settings.handleUpdate({
      ...settings,
      paletteMode: settings.paletteMode === 'light' ? 'dark' : 'light'
    });
  };

  return (
    <Tooltip title={`Switch to ${settings.paletteMode === 'light' ? 'dark' : 'light'} mode`}>
      <IconButton onClick={handleThemeToggle} 
      sx={{
         color:'light'
      }}>
        {settings.paletteMode === 'light' ? <Moon01Icon /> : <SunIcon />}
      </IconButton>
    </Tooltip>
  );
}; 